import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const MainContainer =styled.div.attrs(props => ({
    id: props.id || 'collapsablecard-main-container',
}))`
    display: flex;
    flex-direction: column;
    margin: ${({ margin }) => (margin ? margin : '10px 0px 2px 0px')};
    padding: ${({ padding }) => (padding ? padding : '20px')};
    position: relative;
    background: ${({ background }) =>
        background ? background : '#ffffff 0% 0% no-repeat padding-box'};
    width: ${({ width }) => (width ? width : 'cal(100%-20px)')};
    border-radius: ${({ borderRadius }) =>
        borderRadius ? borderRadius : '6px'};
    box-shadow: ${({ boxShadow }) =>
        boxShadow ? boxShadow : '0px 0px 6px #00000029'};
    border: ${({ border }) => (border ? border : 'none')};
    padding-right: ${({ paddingRight }) =>
        paddingRight ? paddingRight : 'none'};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : 'none'};
    ${media.mobileDevice`
        padding: ${({ mbPadding }) => (mbPadding ? mbPadding : '')};
         margin-bottom: ${({ mbMarginBottom, mainContainerMarginBottom}) =>
        mbMarginBottom ? mbMarginBottom : mainContainerMarginBottom ? mainContainerMarginBottom : 'none'};
        margin:  ${({ mobileMargin }) => (mobileMargin ? mobileMargin : '')};
        padding-bottom: ${({ keyboardPaddingBottom }) => keyboardPaddingBottom};
        width : ${({ mobileCardWidth }) =>
            mobileCardWidth ? mobileCardWidth : ''};
        max-width: ${({ mobileWidth }) => (mobileWidth ? mobileWidth : '')};
    `}
    ${media.mediumDevice`
        margin-bottom:${({ ipadMargin }) => (ipadMargin ? ipadMargin : '')};
        width : ${({ mediumDeviceWidth }) =>
            mediumDeviceWidth ? mediumDeviceWidth : ''};
    `}
    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
`;
export const RowHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${({ isExpanded }) => (isExpanded ? '16px' : '0px')};
    opacity: ${({ opacity }) => (opacity ? opacity : 'none')};
    cursor: pointer;
    margin: ${({ headerMargin }) => (headerMargin ? headerMargin : '0px')};
    ${media.mobileDevice`
        width: ${({ mbHeaderWidth }) => mbHeaderWidth};
        margin: ${({ mbHeaderMargin }) => mbHeaderMargin};
    `}
`;

export const CardTitle = styled.div`
    font-family: 'AvenirNextWorld demi';
   // color: ${({ color }) => (color ? color : '#140f4b')};
    /* font-size: ${({ fontSize }) => (fontSize ? fontSize : '16px')}; */
    ${media.mobileDevice`
    /* font-size: ${({ fontSizeMobile }) =>
        fontSizeMobile ? fontSizeMobile : '15px'}; */
    line-height: ${({ lineHeightMob }) =>
        lineHeightMob ? lineHeightMob : '27px'};
    //color: #140f4b;
     margin-left: ${(props) => props.marginLeft && props.marginLeft};

`}
`;

//optional text
export const OptionTitle = styled.span`
    font-family: ${({ optionValue }) =>
        optionValue ? 'AvenirNextWorld demi' : 'AvenirNextWorld Regular'};
    //color: #140f4b;
    /* font-size: 16px; */
`;

export const EditButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
`;
export const EditButtonStyled = styled.div`
    display: ${({ editButton }) => (editButton ? '' : 'none')};
    width: 30px;
    height: 30px;
    margin-right: ${(props) =>
        props.marginRight ? props.marginRight : '15px'};
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebeded;
    border-radius: 6px;
    opacity: 1;
    cursor: pointer;
    pointer-events: ${(props) => props.editButtonPointerEvents};
`;
export const CollapsableCardMain = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;
